<template>
  <HeaderDashboardCards
    data-testid="responsibilities-header-dashboard"
    aria-label="Responsibilities summary"
    :metrics="cards"
    variant="count-only"
    :columns="5"
    :action-label="activeIndicator ? 'Clear Filter' : 'Apply Filter'"
    @select="handleSelect"
  />
</template>

<script setup>
import { computed } from "vue";
import HeaderDashboardCards from "@components/HeaderDashboardCards/HeaderDashboardCards.vue";

const props = defineProps({
  activeCount: {
    type: Number,
    default: 0,
  },
  draftCount: {
    type: Number,
    default: 0,
  },
  noChecklistCount: {
    type: Number,
    default: 0,
  },
  noRoleAttachedCount: {
    type: Number,
    default: 0,
  },
  notUsedCount: {
    type: Number,
    default: 0,
  },
  /**
   * Key of the card whose filter is currently applied to the list
   * ('active' | 'draft' | 'no-checklist' | 'no-role-attached' | 'not-used').
   * Used for the pressed state only; clicking an active card again resets
   * to the default filter state.
   */
  activeIndicator: {
    type: String,
    default: null,
    validator: (v) =>
      v === null ||
      ["active", "draft", "no-checklist", "no-role-attached", "not-used"].includes(v),
  },
});

const emit = defineEmits(["select-indicator"]);

const cards = computed(() => [
  {
    key: "active",
    title: "Active",
    count: props.activeCount,
    clickable: true,
    active: props.activeIndicator === "active",
  },
  {
    key: "draft",
    title: "Draft",
    count: props.draftCount,
    clickable: true,
    active: props.activeIndicator === "draft",
  },
  {
    key: "no-checklist",
    title: "No checklist",
    count: props.noChecklistCount,
    clickable: true,
    active: props.activeIndicator === "no-checklist",
  },
  {
    key: "no-role-attached",
    title: "No role attached",
    count: props.noRoleAttachedCount,
    clickable: true,
    active: props.activeIndicator === "no-role-attached",
  },
  {
    key: "not-used",
    title: "Not used",
    count: props.notUsedCount,
    clickable: true,
    active: props.activeIndicator === "not-used",
  },
]);

function handleSelect(key) {
  emit("select-indicator", key);
}
</script>
